import { render, staticRenderFns } from "./IncomeCategories.vue?vue&type=template&id=c493c98e&"
import script from "./IncomeCategories.vue?vue&type=script&lang=js&"
export * from "./IncomeCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports